import React from 'react';
import { Flex, FormControl, InputV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

type FaqFormProps = {
  title: string;
  subtitle: string;
  onTitleChange: (value: string) => void;
  onSubtitleChange: (value: string) => void;
};

export const FaqForm = (props: FaqFormProps) => {
  const { tq } = useTranslation('faqCustomComponent');
  const { title, subtitle, onTitleChange, onSubtitleChange } = props;

  return (
    <Flex
      flexDirection="column"
      gap={6}
      paddingBottom="6.5rem"
    >
      <FormControl label={tq`Question`}>
        <InputV2
          placeholder={tq`Enter your question`}
          value={title}
          onChange={e => onTitleChange(e.target.value)}
        />
      </FormControl>

      <FormControl label={tq`Answer`}>
        <InputV2
          as="textarea"
          value={subtitle}
          placeholder={tq`Enter your answer`}
          onChange={e => onSubtitleChange(e.target.value)}
          style={{ resize: 'none' }}
          height="130px"
        />
      </FormControl>
    </Flex>
  );
};
